import { SxProps, Theme } from "@mui/material";

export const dialogPaperStyles: SxProps<Theme> = {
  borderRadius: "0.5rem",
  minWidth: "20rem",
  maxWidth: "26.25rem",
  alignItems: "center",
};

export const dialogTitleStyles: SxProps<Theme> = {
  pb: "0.5rem",
  pt: "1.25rem",
  px: "1.5rem",
};

export const titleBoxStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
};

export const getTitleTypographyStyles = (theme: Theme): SxProps<Theme> => ({
  fontWeight: 600,
  fontSize: "1.25rem",
  color: theme.palette.text.primary,
});

export const dialogContentStyles: SxProps<Theme> = {
  px: "1.5rem",
  py: "1.25rem",
  textAlign: "center",
};

export const getContentTypographyStyles = (theme: Theme): SxProps<Theme> => ({
  color: theme.palette.text.secondary,
  fontSize: "1rem",
  fontWeight: 400,
  lineHeight: 1.5,
});

export const dialogActionsStyles: SxProps<Theme> = {
  px: "1.5rem",
  py: "1rem",
  pt: "0.75rem",
};

export const confirmButtonStyles: SxProps<Theme> = {
  fontSize: "0.75rem",
  textTransform: "none",
  py: "0.25rem",
  px: "0.75rem",
};
